"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VideoOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.1 8l-.8.2-2.6 1.6a4 4 0 00-1.7 3v6.4a4 4 0 001.7 3l2.6 1.6.8.2c.5 0 .9-.4.9-1.2V9.2c0-.8-.4-1.2-.9-1.2zM28 21.2l-1.3-.7a2.1 2.1 0 01-.7-1.3v-6.4a2.1 2.1 0 01.7-1.3l1.3-.7zM20.8 7H3.2A1.2 1.2 0 002 8.2v15.6A1.2 1.2 0 003.2 25h17.6a1.2 1.2 0 001.2-1.2V8.2A1.2 1.2 0 0020.8 7zM20 23H4V9h16z"/><path d="M12 11a5 5 0 105 5 5 5 0 00-5-5zm0 8a3 3 0 113-3 2.9 2.9 0 01-3 3z"/>';
var VideoOutlineSVG = function VideoOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.VideoOutlineSVG = VideoOutlineSVG;
VideoOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(VideoOutlineSVG);
exports.default = _default;